<template>
  <div>
    <div class="fast-modal-content">
      <!-- input is used for matomo analytics -->
      <input ref="input" hidden type="text" name="category_id" />

      <Teleport to="#fast-title">Choisissez une catégorie</Teleport>

      <Loading v-show="loading" />

      <div class="fast-modal-btns">
        <ButtonSelect
          v-for="category in displayedCategories"
          :key="category.id"
          :label="category.name"
          :selected="categoryId === category.id"
          @click="handleClick(category.id)"
        />
      </div>
      <button
        v-if="displayedCategories.length !== categories.length"
        type="button"
        class="btn btn-link text-body"
        @click.prevent="displayAllCategories = true"
      >
        afficher toutes les catégories
      </button>
    </div>
    <StepsNavigation
      :next-step-disabled="project.categoryId === null"
      @prevStep="handlePrevStep"
      @nextStep="handleNextStep"
    />
  </div>
</template>

<script>
import axios from 'axios'

import stepEvents from '../mixins/stepEvents'
import ButtonSelect from './ButtonSelect.vue'
import Loading from './Loading.vue'
import StepsNavigation from './StepsNavigation.vue'

export default {
  name: 'StepCategory',
  components: {
    ButtonSelect,
    Loading,
    StepsNavigation
  },
  mixins: [stepEvents],
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      categories: [],
      displayAllCategories: false
    }
  },
  computed: {
    categoryId() {
      if (this.project === null) {
        return
      }
      return this.project.categoryId
    },
    relevantCategories() {
      return this.categories.slice(0, 4)
    },
    selectedCategoryIsVisible() {
      if (this.categoryId === null) {
        return true
      }
      return this.relevantCategories.some(c => c.id === this.categoryId)
    },
    displayedCategories() {
      if (this.displayAllCategories) {
        return this.categories
      }
      if (this.categoryId === null || this.selectedCategoryIsVisible) {
        return this.relevantCategories
      }

      return this.categories
    }
  },
  mounted() {
    this.$refs.input.value = this.categoryId
    axios
      .post('/api/project_category_predictions', {
        project: {
          title: this.project.title,
          description: this.project.description
        }
      })
      .then(response => {
        this.categories = response.data.project_category_predictions
        this.loading = false
      })
  },
  methods: {
    handleClick(id) {
      this.$refs.input.value = id
      this.$emit('attributeChange', 'categoryId', id)
      this.$emit('nextStep')
    }
  }
}
</script>
